export function softmax(logits, temperature = 1) {
  const scaled = Array.from(logits, (value) => value / temperature);
  const max = Math.max(...scaled);
  const exps = scaled.map((value) => Math.exp(value - max));
  const sum = exps.reduce((acc, value) => acc + value, 0);
  return exps.map((value) => value / sum);
}

export function entropyRatio(probs) {
  const entropy = -probs.reduce((acc, p) => acc + (p > 0 ? p * Math.log(p) : 0), 0);
  return probs.length > 1 ? entropy / Math.log(probs.length) : 0;
}

export function argmax(values) {
  let best = 0;
  for (let i = 1; i < values.length; i += 1) if (values[i] > values[best]) best = i;
  return best;
}

export function averageDistributions(list) {
  if (!list.length) return [];
  const sum = new Array(list[0].length).fill(0);
  list.forEach((probs) => probs.forEach((p, i) => { sum[i] += p; }));
  return sum.map((value) => value / list.length);
}
